import React, { useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";
import ErrorMessage from "./ErrorMessage";

export default function EnvInput({
  name,
  type = 'text',
  placeholder = null,
  autoComplete = null,
  required = true,
  onChange = (e) => null,
  extraOnChange = (e) => null,
  readOnly = false,
  tabIndex = 0,
  onBlur = (e) => null
}) {
  const {
    order,
    setOrder
  } = useContext(CarOrderingContext)

  const _onChange = (e) => {
    order[name] = e.target.value
    setOrder({ ...order })

    onChange(e)
    extraOnChange(e)
  }

  return (
    <>
      <input
        type={type}
        defaultValue={order[name]}
        name={name}
        id={name}
        placeholder={placeholder}
        onChange={_onChange}
        autoComplete={autoComplete}
        tabIndex={tabIndex}
        readOnly={readOnly}
        onBlur={onBlur}
      />

      {required === true && (
        <ErrorMessage field={name}/>
      )}
    </>
  )
}
